import { ColumnTypes, InternalColumnTypes } from "./column-types";
import { ContentDataSchemaField } from "../../../apis/stateful-content";
import { renderStatus } from "./cells/status";
import { renderText } from "./cells/text";
import { renderDate } from "./cells/date";
import { renderDetailLink } from "./cells/detailLink";
import { renderLatestAvailableSoftwareVersion } from "./cells/latestAvailableSoftwareVersion";
import { renderFavToggle } from "./cells/favToggle";
import { renderTextAndDate } from "./cells/textAndDate";
import { renderDiscontinuedInfo } from "./cells/discontinuedInfo";
import { renderTextWithConditionalTooltip } from "./cells/textWithConditionalTooltip";
import { renderCheckbox } from "./cells/checkbox";
import { renderEquipment } from "./cells/equipment";
import { renderMachineName } from "./cells/machineName";

export interface TableCellProps {
    item: any;
    columnKey: string;
    schemaItem: ContentDataSchemaField;
    translate?: (key: string) => string;
}

const getRenderer = (cellType: ColumnTypes | InternalColumnTypes) => {
    switch (cellType) {
        case ColumnTypes.FavToggle:
            return renderFavToggle;
        // Deprecated in favor of MachineName
        case ColumnTypes.DiscontinuedInfo:
            return renderDiscontinuedInfo;
        case ColumnTypes.MachineName:
            return renderMachineName;
        case ColumnTypes.LatestAvailableSoftwareVersion:
            return renderLatestAvailableSoftwareVersion;
        case ColumnTypes.Status:
            return renderStatus;
        case ColumnTypes.DetailLink:
            return renderDetailLink;
        case ColumnTypes.Date:
            return renderDate;
        case InternalColumnTypes.TextAndDate:
            return renderTextAndDate;
        case ColumnTypes.TextWithConditionalTooltip:
            return renderTextWithConditionalTooltip;
        case ColumnTypes.Checkbox:
            return renderCheckbox;
        case ColumnTypes.Equipment:
            return renderEquipment;
        case ColumnTypes.Text:
        default:
            return renderText;
    }
};

export const TableCell = ({
    item,
    columnKey,
    schemaItem,
    translate,
}: TableCellProps) => {
    if (schemaItem.type === "hidden") {
        return null;
    }
    return getRenderer(schemaItem.type)({
        item,
        columnKey,
        schemaItem,
        translate,
    });
};
